export const routes = ( prefix ) => [
    {
        path: `/${prefix}/lab-setup/lab-test-components`,
        name: `${prefix}.lab-setup.lab-test-components.index`,
        component: () => import('./lab-test-comp/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.lab-setup.lab-test-components.index`,
                PageDescription: "Lab test components listing",
            }
        }
    },
    {
        path: `/${prefix}/lab-setup/lab-test-components-reporting`,
        name: `${prefix}.lab-setup.lab-test-components-reporting.index`,
        component: () => import('./lab-test-reporting/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.lab-setup.lab-test-components-reporting.index`,
                PageDescription: "Lab test components Reporting",
            }
        }
    },
    {
        path: `/${prefix}/lab-setup/lab-test-items`,
        name: `${prefix}.lab-setup.lab-test-items.index`,
        component: () => import('./lab-test-items/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.lab-setup.lab-test-items.index`,
                PageDescription: "Lab test Items",
            }
        }
    },{
        path: `/${prefix}/lab-setup/item-consumable-deduction`,
        name: `${prefix}.lab-setup.item-consumable-deduction.index`,
        component: () => import('./item-consumable-deduction/Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.lab-setup.item-consumable-deduction.index`,
                PageDescription: "Item Consumable Deduction",
            }
        }
    },
];
